"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OperatorSelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Select = _interopRequireDefault(require("@cimpress/react-components/lib/Select"));

var _operators = require("../../shared/enums/operators");

var _options = require("../../shared/enums/options");

var _messages = _interopRequireDefault(require("./messages"));

var _operatorMessages = _interopRequireDefault(require("../../shared/messages/operatorMessages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var generateOperator = function generateOperator(operator, formatMessage) {
  var translatedString = _operatorMessages["default"][operator];

  if (!translatedString) {
    return operator;
  }

  return formatMessage(translatedString);
};

var OperatorSelector = function OperatorSelector(_ref) {
  var attributeType = _ref.attributeType,
      selectedOperator = _ref.selectedOperator,
      onSelectionChanged = _ref.onSelectionChanged;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var operatorOptions = [];

  if (attributeType) {
    var validOperations = attributeType === _options.STRING ? _operators.SELECT_OPERATOR_TYPES : _operators.OPERATOR_TYPES;
    operatorOptions = Object.values(validOperations).map(function (operatorType) {
      return {
        value: operatorType,
        label: generateOperator(operatorType, formatMessage)
      };
    });
  }

  return (
    /*#__PURE__*/
    _react["default"].createElement(_Select["default"], {
      id: "OperatorSelector",
      clearable: false,
      label: formatMessage(_messages["default"].label),
      value: operatorOptions.filter(function (option) {
        return option.value === selectedOperator;
      }),
      options: operatorOptions,
      onChange: function onChange(selectedValue) {
        onSelectionChanged(selectedValue.value);
      }
    })
  );
};

exports.OperatorSelector = OperatorSelector;
OperatorSelector.propTypes = {
  attributeType: _propTypes["default"].oneOf([_options.NUMBER, _options.STRING]),
  selectedOperator: _propTypes["default"].oneOf([null, ''].concat(_toConsumableArray(Object.values(_operators.OPERATOR_TYPES)))),
  onSelectionChanged: _propTypes["default"].func.isRequired
};
OperatorSelector.defaultProps = {
  attributeType: null,
  selectedOperator: ''
};
var _default = OperatorSelector;
exports["default"] = _default;